import React from "react";
import { css } from "styled-components/macro"; // eslint-disable-line
import tw from "twin.macro";
import styled from "styled-components";

// Setting fixed width and height for all cards
const CardContainer = styled.div`
  ${tw`px-3 py-3 mt-6`}
  width: 380px; /* Reduced width for cards */
  height: 200px; /* Reduced height for cards */
  overflow: hidden; /* Prevents scrolling */
`;

const Card = styled.div`
  ${tw`bg-gray-100 rounded-lg shadow-lg overflow-hidden flex flex-col`};
  height: 100%; /* Ensures the card takes the full height of the container */
`;

const CardImage = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`bg-cover bg-center w-full`}
  height: 100px; /* Reduced image height */
  flex-shrink: 0; /* Ensure the image doesn't shrink */
`;

const CardInfo = styled.div`
  ${tw`p-3 flex-1 border-t flex flex-col justify-between`}
`;

const CardTitle = styled.div`
  ${tw`text-sm font-semibold mt-1 text-gray-900`}
  max-height: 2.2rem; /* Adjusted for smaller text area */
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; /* For multiline truncation */
`;

const CustomCard = ({ imageSrc, title }) => {
  return (
    <CardContainer>
      <Card>
        <CardImage imageSrc={imageSrc} />
        <CardInfo>
          <CardTitle>{title}</CardTitle>
        </CardInfo>
      </Card>
    </CardContainer>
  );
};

export default CustomCard;
